module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/productos/categoria-producto/categoria-producto.component.html
// module id = ./src/app/productos/categoria-producto/categoria-producto.component.html
// module chunks = main